/* CarGauge product card (Task 05B): keep aria-pressed on the card wishlist button in step
   with the state class the existing theme.wishlist code already toggles ("whislist-added").
   Read-only with respect to wishlist logic: it never adds/removes the class, never touches
   localStorage and adds no click handlers. */
(function () {
  'use strict';
  var SEL = 'button.cg-pc__wish[data-icon-wishlist]';

  function sync(btn) {
    var on = btn.classList.contains('whislist-added') ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== on) btn.setAttribute('aria-pressed', on);
  }

  function syncAll(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) sync(list[i]);
  }

  function start() {
    syncAll();
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.nodeType === 1 && t.matches && t.matches(SEL)) sync(t);
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
